import React from 'react'

export default function Service({ children }) {
    return (
        <article className='container content blog-content'>{children}</article>
    )
}
